// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + {"76":"designer","594":"about"}[chunkId] + "." + {"76":"d1754636","594":"f12bdf29"}[chunkId] + ".js";
};